import { dataProps } from './properties'

export const setOvertimeMasterList = (state, payload) => {
    state.list = payload
}    

export const setOvertimeMasterData = (state, payload) => {
    state.props = payload
} 

export const resetOvertimeMasterData = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/overtimeMaster/mutations.js